import { ReactNode, useEffect, useCallback } from 'react';
import { SnackbarProvider as Provider, useSnackbar } from 'notistack';

const SnackBarListener = () => {
  const { enqueueSnackbar } = useSnackbar();

  const pushErrorToSnackBar = useCallback(
    (error: any) => enqueueSnackbar(error.detail, { variant: 'error' }),
    [enqueueSnackbar]
  );

  const addEvent = useCallback(() => window.addEventListener('errorEvent', pushErrorToSnackBar), [pushErrorToSnackBar]);
  const removeEvent = useCallback(
    () => window.removeEventListener('errorEvent', pushErrorToSnackBar),
    [pushErrorToSnackBar]
  );

  useEffect(() => {
    addEvent();

    return () => removeEvent();
  }, [addEvent, removeEvent]);

  return <></>;
};

type SnackBarProviderProps = {
  children: ReactNode;
};

const SnackBarProvider = ({ children }: SnackBarProviderProps) => (
  <Provider>
    <SnackBarListener />
    {children}
  </Provider>
);

export default SnackBarProvider;
